module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAhCAYAAAC1ONkWAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEZJREFUeNrs17ENACAIAEF1EkdxFDd1NGQICxLvGtpPKNDWiuoRMXPuimEr56kWNqquUhjAb9xKYd8+FAF8eN1KYbx1BRgAwjcWhBCC0x0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-menu.png
// module id = 54uL
// module chunks = 1